export const AppContext = { appName: "Abiliti Policy" };
